import { abreviaturas, masterEvents } from 'constantes';
import { PdfViewerBusiness } from 'business/business/PdfViewerBusiness';
import { AnalyticsAmplitud } from './Analytics-Amplitud';

/**
 * @name blobToBase64
 * @desc Función que convierte un binario en base64
 * @param blob
 * @returns {Promise}
 */
export const blobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
        resolve(reader.result);
    };
    reader.readAsDataURL(blob);
});

/**
 * Función que convierte un B64 a binario
 * @param b64
 * @returns {Promise}
 */
export const base64ToBlob = (b64) => new Promise((resolve) => {
    const binaryString = window.atob(b64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < len; ++i) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    resolve(new Blob([bytes], { type: abreviaturas.DEFAULT_TYPE_CONTENT_IMAGE }));
});

/**
 * @name mapValues
 * @desc Metodo donde se setean valores segun el api
 * @param formValues
 * @returns {{estado: string, idEstado: number, mensajeError}}
 */
const mapValues = (status, idStatus) => ({
    estado: status,
    mensajeError: null,
    idEstado: idStatus,
});

/**
 * @name onChangeStatusDoc
 * @desc Cambia el estado de un documento segun parametros
 * @param status
 * @param idStatus
 * @param solicitudId
 * @returns {Promise<void>}
 */
export const onChangeStatusDoc = async (status, idStatus, solicitudId) => {
    try {
        const data = await mapValues(status, idStatus);
        // Se envia solicitud al api
        await PdfViewerBusiness.postDocumentReaderStatus(data, solicitudId);
    } catch (e) {
        throw new Error(e);
    }
};

/**
 * @name validatePermissionDoc
 * @desc Valida si el usuario tiene o no permisos para ver un doc
 * @returns {Promise<boolean>}
 */
export const validatePermissionDoc = async (solicitudId) => {
    try {
        // Se envia solicitud al api
        const res = await PdfViewerBusiness.validatePermission(solicitudId);
        // eslint-disable-next-line max-len
        if (res.status === abreviaturas.DEFAULT_HTTP_OK[0] || res.status === abreviaturas.DEFAULT_HTTP_OK[1]) {
            return false;
        }
        // eslint-disable-next-line max-len
        if (res.status === abreviaturas.DEFAULT_HTTP_FAIL[0] || res.status === abreviaturas.DEFAULT_HTTP_FAIL[1]) {
            // Conexión con analiticas al no tener permisos
            AnalyticsAmplitud.registerEvent(masterEvents.EVENTO_SIN_PERMISO);
            return true;
        }
        return true;
    } catch (e) {
        throw new Error(e);
    }
};

/**
 * @name getUserLocation
 * qdesc Devuelve la geolocalización del usuario
 * @returns {Promise}
 */
export const getUserLocation = async () => new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
        ({ coords, timestamp }) => {
            resolve([
                coords.latitude, coords.longitude, coords.heading, coords.accuracy, timestamp,
            ]);
        },
    );
});
